import { ShowcaseTemplateProps } from "../../constants/types";
import EplusTableCard from "../organisms/showcase/EplusTableCard";
import ShowcaseTableCard from "../organisms/showcase/ShowcaseTableCard";
import PublicTemplate from "../publics/PublicTemplate";

const ShowcaseTemplate = (props: ShowcaseTemplateProps) => {
  return (
    <PublicTemplate justify="space-between">
      <>
        <ShowcaseTableCard
          option={props.option}
          categories={props.categories}
          data={props.data.showcase}
          render={props.render}
          page={props.showcasePage}
        />
        <EplusTableCard
          data={props.data.eplus}
          option={props.option}
          categories={props.categories}
          render={props.render}
          page={props.eplusPage}
        />
      </>
    </PublicTemplate>
  );
};

export default ShowcaseTemplate;
